import type { Guide } from '../types';

/** S-28.10-02 — instrukcja obsługi w aplikacji (scenariusz e2e 40). */
export const guide: Guide = {
  flagKey: 'userManual',
  title: 'Instrukcja obsługi',
  whatItDoes:
    'Nowa pozycja menu „Instrukcja” dla każdego zalogowanego. Rozdziały według działów i ról: Pierwsze kroki, Planista FTL, Team Leader FTL, Trade, CS, Administracja i Administrator. Na start otwiera się rozdział Twojej roli, a wyszukiwarka szuka po całym tekście. Każdy rozdział mówi, do czego służą ekrany, jak wykonać typowe zadania krok po kroku i co znaczą stany, znaczniki i ostrzeżenia. Opisy funkcji pokazują się tylko wtedy, gdy funkcja jest dla Ciebie włączona.',
  audience: ['wszyscy pracownicy'],
  presentationItems: ['S-28.10-02'],
  steps: [
    {
      route: '/manual',
      target: 'manual-chapters',
      title: 'Rozdziały według działów',
      description:
        'Po lewej rozdziały instrukcji. Rozdział Twojej roli jest oznaczony „Twoja rola” i otwiera się na start.',
      action: 'Kliknij rozdział innego działu, żeby zobaczyć, jak pracują koledzy.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/manual',
      target: 'manual-toc',
      title: 'Spis treści rozdziału',
      description:
        'Na górze rozdziału spis sekcji; niżej opisy ekranów, zadania krok po kroku, słowniczki stanów i znaczników oraz zrzuty ekranów.',
      action: 'Kliknij tytuł sekcji w spisie, żeby do niej przejść.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/manual',
      target: 'manual-search-results',
      title: 'Wyszukiwarka',
      description:
        'Wpisz słowo albo frazę — wyniki pokazują rozdział, sekcję i fragment tekstu. Wielkość liter i polskie znaki nie mają znaczenia.',
      action: 'Wpisz na przykład „wariant” i kliknij wynik.',
      recorder: { account: 'ftl', actions: [{ kind: 'fill', target: 'manual-search', value: 'wariant' }] },
    },
  ],
};
